import * as React from 'react'

const ToolsIcon = React.forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement>
>((props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="20"
    fill="none"
    viewBox="0 0 21 20"
    ref={ref}
    {...props}
  >
    <path
      fill="#71717A"
      d="m2.625.25-.422.398-1.055 1.055-.398.422.305.492 1.57 2.625.21.375H5.04l3 2.977-6.21 6.235c-1.176 1.174-1.178 3.098.022 4.218 1.172 1.157 3.082 1.187 4.196 0l.022-.024 4.618-4.64 4.64 4.664.07.047c1.178 1.11 3.05 1.125 4.15-.047v-.023h.022c1.149-1.175 1.16-3.086-.023-4.196l-.024-.023-3.913-3.89c2.633-.247 4.695-2.47 4.734-5.157h.023c.003-.015 0-.032 0-.047v-.024a3.88 3.88 0 0 0-.562-2.414l-.515-.796-3.493 3.493-1.054-1.102 3.562-3.563-1.031-.421a5.25 5.25 0 0 0-2.087-.446c-2.882 0-5.25 2.367-5.25 5.25 0 .313.068.585.118.867-.328.328-.574.597-.961.984L6.117 4.563V2.336l-.375-.211L3.117.555zm12.563 1.688c.104 0 .178.061.28.07l-2.835 2.836.515.539 2.11 2.18.515.539 2.977-2.977c.015.173.138.298.117.492v.07a3.757 3.757 0 0 1-3.75 3.75c-.275 0-.609-.064-.984-.14l-.399-.07-.281.281-8.46 8.484h-.024v.024c-.533.583-1.465.597-2.086-.024v-.023h-.024c-.583-.533-.597-1.465.024-2.086.284-.285 5.789-5.836 8.484-8.531l.305-.305-.117-.422a4.5 4.5 0 0 1-.117-.937 3.757 3.757 0 0 1 3.75-3.75m-12.329.187 1.758 1.079v.75l-.163.163h-.75L2.625 2.36zm10.969 9.117 4.665 4.641v.023h.022c.584.533.598 1.465-.022 2.086h-.024v.024c-.533.583-1.465.597-2.086-.024l-4.641-4.664z"
    ></path>
  </svg>
))

ToolsIcon.displayName = 'ToolsIcon'

export { ToolsIcon }
